import type {
  CustomFieldValues,
  MappingCustomFieldAdvancedLinks,
} from '~/types';

export type CustomFieldValueGetByClientIdRequest = {
  clientId: string;
};

export type CustomFieldValueGetByClientIdResponse = {
  item: {
    orgId?: string;
    clientId: string;
    rolloutId: string;
    inventoryId: string;
    values?: CustomFieldValues;
    created?: string;
    updated?: string;
    mappingCustomFieldAdvancedLinks: MappingCustomFieldAdvancedLinks;
  } | null;
};

export function useApiCustomFieldValue() {
  const { $client } = useNuxtApp();

  const getByClientId = async (
    request: CustomFieldValueGetByClientIdRequest
  ): Promise<CustomFieldValueGetByClientIdResponse> => {
    const response =
      await $client.customFieldValue.getByClientId.query(request);
    return response;
  };

  return { getByClientId };
}
